import { Map } from 'immutable';
export default class ConfigStore {
    constructor() {
        this._store = Map();
    }
    set(key, value) {
        this._store = this._store.set(key, value);
    }
    get(key) {
        return this._store.get(key);
    }
}



// WEBPACK FOOTER //
// ./ext/editor-core/src/EditorCore/ConfigStore.ts